import { CallPeriod, CallPeriodRange } from "@/app/types/call/CallPeriod";
import { UCookie } from "@/app/utils/UCookie";
import { CookieKey, WORKSPACE_COOKIE_MAX_AGE } from "@/app/vars/Storage";

export class UCallPeriod {
  private static readonly PRESET_DAYS: Partial<Record<CallPeriod, number>> = {
    [CallPeriod.LAST_7_DAYS]: 7,
    [CallPeriod.LAST_30_DAYS]: 30,
    [CallPeriod.LAST_90_DAYS]: 90,
    [CallPeriod.LAST_12_MONTHS]: 365,
  };

  public static toDay(date: Date): string {
    return date.toISOString().slice(0, 10);
  }

  public static resolve(period: CallPeriod, custom: CallPeriodRange = {}): CallPeriodRange {
    if (period === CallPeriod.CUSTOM) {
      return { from: custom.from || undefined, to: custom.to || undefined };
    }

    if (period === CallPeriod.THIS_YEAR) {
      return { from: `${new Date().getFullYear()}-01-01` };
    }

    const days = UCallPeriod.PRESET_DAYS[period];
    if (days === undefined) {
      return {};
    }

    const from = new Date();
    from.setDate(from.getDate() - days);

    return { from: UCallPeriod.toDay(from) };
  }

  public static parsePeriod(raw?: string | null): CallPeriod | null {
    return raw && Object.values(CallPeriod).includes(raw as CallPeriod)
      ? (raw as CallPeriod)
      : null;
  }

  public static parseRange(raw?: string | null): CallPeriodRange {
    try {
      const parsed = raw ? (JSON.parse(raw) as CallPeriodRange) : {};
      return { from: parsed.from || undefined, to: parsed.to || undefined };
    } catch (_error) {
      return {};
    }
  }

  public static store(period: CallPeriod, range: CallPeriodRange): void {
    UCookie.write(CookieKey.CALL_ANALYSIS_PERIOD, period, WORKSPACE_COOKIE_MAX_AGE);
    UCookie.write(
      CookieKey.CALL_ANALYSIS_PERIOD_RANGE,
      JSON.stringify(range),
      WORKSPACE_COOKIE_MAX_AGE,
    );
  }

  public static isActive(period: CallPeriod, custom: CallPeriodRange = {}): boolean {
    if (period === CallPeriod.CUSTOM) {
      return !!custom.from || !!custom.to;
    }

    return period !== CallPeriod.ALL;
  }
}
